import { memo } from 'react';
import { Box, Button, Image, RenderHtml } from '@bonanza-social/moonlight';
import { PrizeWallPrizeInfoProps } from './PrizeWallPrizeInfo.types';

function PrizeWallPrizeInfo({
  imageUrl,
  description,
  close,
}: PrizeWallPrizeInfoProps) {
  return (
    <Box gap="space-400">
      <Image source={imageUrl} width="100%" aspectRatio={1.5} />
      <RenderHtml
        html={description ?? ''}
        variant="body-s"
        textAlign="center"
        color="darkSurfacePrimary"
      />
      <Button
        locNS="common"
        locKey="close"
        onPress={close}
        marginTop="space-200"
      />
    </Box>
  );
}

export default memo(PrizeWallPrizeInfo);
